<template>
    <v-tooltip top>
      
      <template v-slot:activator="{ on, attrs }">
        <span v-on="on"
              v-bind="attrs">
            <slot></slot>
        </span>
      </template>
      
      <span>
        <span v-if="checkPermission">
            {{ item.title }}
        </span>
        <span v-else>
            Non hai accesso a questo contenuto.
        </span>
      </span>

    </v-tooltip>
</template>

<script>

export default 
{
   name: 'GridTooltip',

   mixins: [],

   components:
   {

   },

   data: () => ({
     
   }),

   props:
   {
      item:
      {
         required: true
      }
   },

   computed:
   {
     checkPermission()
     {
        return (!this.item.hasLoadPermission('can_read') || this.item.canRead)
     }
   },

   methods:
   {
     
   },

   watch:
   {
    
   },

   mounted()
   {

   }
}
</script>